<template>
  <div>
    <div
      class="grid"
      style="display: flex;flex-wrap: wrap;"
    >
      <div
        v-for="(m, key) in existingFiles_"
        :key="m.id"
        class="item"
      >
        <v-upload-item
          :file="m"
          @delete="deleteMedia(key)"
        />
      </div>
    </div>

    <b-field class="mb-2 is-full">
      <b-upload
        :loading="uploading"
        drag-drop
        native
        multiple
        accept="image/*"
        class="is-full"
        @input="onInput"
      >
        <section class="section is-full">
          <div class="content has-text-centered">
            <p>
              <b-icon
                icon="upload"
                size="is-large"
              />
            </p>
            <p>{{ $t("drop_or_click_to_upload") }}</p>
          </div>
        </section>
      </b-upload>
    </b-field>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import UploadPictureItem from "./UploadPictureItem";

import { resizeImage, convertHeicImage } from "@/services/helpers";

export default {
  components: {
    draggable,
    "v-upload-item" : UploadPictureItem
  },
  props: {
    resize: {
      default: 1000,
      type: Number,
    },
    existingFiles: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      uploads: [],
      uploading: false,
      drag: false,
      existingFiles_: _.cloneDeep(this.existingFiles),
      newFiles: [],
      toRemove: [],
      imageConversionMimeTypes:[
        "image/heic",
        "image/heif",
      ]
    };
  },
  methods: {
    onDragend() {
      this.drag = false;
      this.onInput(this.uploads);
      this.uploads = [];
    },
    async onInput(files) {

      for (let i = 0; i < files.length; i++) {
        await this.addMedia(files[i]);

      }
      this.sync();
    },
    async addMedia(file)
    {
      this.uploading = true;

      if (file.type.includes("image")) {

        if (this.imageConversionMimeTypes.includes(file.type)) {
          file = await convertHeicImage(file);
        }

        file = await this.resizeImg(file);
      }
      this.newFiles.push(file);
      this.existingFiles_.push(file);
      this.uploading = false;
    },
    resizeImg(file) {
      return resizeImage(file, 1000);
    },
    // Works for both an already-stored media (queued for removal) and a
    // file picked in this session that is not uploaded yet
    deleteMedia(index) {
      const file = this.existingFiles_[index];

      if (!file) {
        return;
      }
      if (file instanceof File) {
        const i = this.newFiles.indexOf(file);

        if (i !== -1) {
          this.newFiles.splice(i, 1);
        }
      } else if (file.id) {
        this.toRemove.push(file.id);
      }
      this.existingFiles_.splice(index, 1);
      this.sync();
    },
    sync() {
      this.$emit("input", {
        to_remove: this.toRemove,
        to_add: this.newFiles
      });
    },
  },
};
</script>
